import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import Multiselect from '../EventModal/components/Multiselect'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import Editor from 'components/editor'
import CreateCollectionModal from './Collections/createModal'

const CreateModal = ({ editData, appData, handleRefresh, appCollections, appTriggerModel }) => {
  appCollections = appCollections.filter((data) => data.app_id === appData?.app_id)

  const uploadImage = useUploadImage()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const { app_id } = useParams
  const [user] = useUserInfo()
  var axios = require('axios')
  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  useEffect(async () => {}, [])
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [editor, setEditor] = useState('')
    const [hasUIInterface, setHasUIInterface] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      //   const image_response = await uploadImage({
      //     file: e.target.image.files[0],
      //     desiredPath: `app/logo/image`,
      //   })
      const selectedTriggerModels = JSON.parse(e.target.app_trigger_keys.value)

      const trigger_data = {
        name: e.target.name.value,
        description: editor,
        app_collection_id: e.target.app_collection.value,
        link: e.target.link.value,
        key: e.target.key.value,
        hasUIInterface,
        app_trigger_keys: selectedTriggerModels?.map((item) => item.value) || [],
        sample_response: e.target.sample_response.value,

        // image: image_response.response.data,
      }
      const payload = {
        _id: appData._id,
        triggers: [...(appData.triggers || []), trigger_data],
      }
      console.log('payload', payload)
      const { response } = await AppService.app.update({
        payload: payload,
      })

      if (response) {
        const payload_collection = {
          app_id: appData.app_id,
          id: e.target.app_collection.value,
          triggers: [
            ...(appCollections.find((data) => data._id === e.target.app_collection.value)
              ?.triggers || []),
            trigger_data,
          ],
        }
        console.log(payload_collection, 'payload_collection')
        const res = AppService.AppCollections.update({
          payload: payload_collection,
        })

        if (res) {
          setProcessing(false)
          onClose()
          handleRefresh()
        }
      }
    }
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 700,
      height: '80vh',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
      overflowY: 'auto',
    }
    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              App Trigger
            </MDTypography>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <Editor
                handleChange={(data) => {
                  setEditor(data)
                }}
                data={editor}
              />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Youtube Link
              </MDTypography>
              <MDInput label="Youtube Link" name="link" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Trigger Key
              </MDTypography>
              <MDInput label="Trigger Key" name="key" fullWidth />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Select Collection
              </MDTypography>
              <Select placeholder="Actions Category" name="app_collection" fullWidth>
                {appCollections?.map((data) => (
                  <MenuItem value={data?._id}>{data?.name}</MenuItem>
                ))}
              </Select>
            </MDBox>

            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hasUIInterface}
                      onChange={(e) => setHasUIInterface(e.target.checked)}
                      name="hasUIInterface"
                    />
                  }
                  label="Is trigger have UI interface"
                />
              </FormGroup>
            </MDBox>

            {hasUIInterface && (
              <MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Select Trigger Keys
                  </MDTypography>
                  <Multiselect
                    name="app_trigger_keys"
                    isMulti={true}
                    data={appTriggerModel?.map((data) => ({
                      value: { id: data?._id, name: data?.name, key: data?.key, sample_response: data?.sample_response },
                      label: data?.name,
                    }))}
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Sample Response
                  </MDTypography>
                  <MDBox 
                   sx={{
                    maxHeight: '150px',
                    overflowY: 'auto',
                    
                    borderRadius: '4px',
                    
                  }}>
                    <TextareaAutosize
                      type="text"
                      name="sample_response"
                      minRows={3}
                      style={{ width: '100%' }}
                    />
                  </MDBox>
                </MDBox>
              </MDBox>
            )}
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <div className="flex justify-end gap-4 items-center">
        {/* <CreateCollectionModal appData={appData} handleRefresh={handleRefresh} /> */}

        <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
          Create Trigger
        </MDButton>
        <AddProduct open={openAddProduct} onClose={closeAddProduct} />
      </div>
    </>
  )
}

export default CreateModal
